import { site } from '../content/site';
import './Capabilities.css';

export default function Capabilities() {
  return (
    <section
      className="capabilities section"
      aria-labelledby="capabilities-heading"
    >
      <div className="container">
        <div className="capabilities__head">
          <span className="eyebrow">What I do</span>
          <h2 id="capabilities-heading" className="capabilities__heading display">
            I help clients to deliver enjoyable, data-driven and most importantly, accessible experiences.
          </h2>
        </div>
        <ul className="capabilities__grid">
          {site.capabilities.map((c) => (
            <li key={c.title} className="capabilities__item">
              <h3 className="capabilities__item-title">{c.title}</h3>
              <p className="capabilities__item-detail">{c.detail}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
